<template>
	<div id="app">
		<van-nav-bar v-show="showNav" border :left-arrow="showBack" @click-left="back" :title="title"></van-nav-bar>
		<transition :name="transitionName">
			<router-view class="router-view" :class="{'show-nav': showNav, 'show-tab': showTab}"/>
		</transition>
		<van-tabbar v-show="showTab" border v-model="active">
		  <van-tabbar-item icon="home-o" to="home">首页</van-tabbar-item>
		</van-tabbar>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				transitionName: 'slide-right',
				showNav: false,
				showTab: true,
				title: '首页',
				showBack: false,
				active: 0
			}
		},
		watch: {
			'$route'(to, from) {
				let isBack = this.$router.isBack //  监听路由变化时的状态为前进还是后退
				if (isBack) {
					this.transitionName = 'slide-right'
				} else {
					this.transitionName = 'slide-left'
				}
				this.$router.isBack = false
				if (to.meta.showNav) {
					this.showNav = true
				} else {
					this.showNav = false
				}
				if (to.meta.showTab) {
					this.showTab = true
				} else {
					this.showTab = false
				}
				if (to.meta.title) {
					this.title = to.meta.title
				} else {
					this.title = ''
				}
				if (to.meta.showBack) {
					this.showBack = true
				} else {
					this.showBack = false
				}
			}
		},
		methods: {
			back() {
				this.$router.goBack()
			}
		}
	}
</script>
<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #333333;
	}

	#nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
	
	.router-view {
		 position: absolute;
		 left: 0;
		 right: 0;
		 top: 0;
		 bottom: 0;
		 transition: all .2s ease;
		 overflow: scroll;
		 &.show-nav {
			 top: 47px;
		 }
		 &.show-tab {
			 bottom: 51px;
		 }
	}
	
	.slide-left-enter,
	 .slide-right-leave-active {
	     opacity: 0;
	    -webkit-transform: translate(100%, 0);
	    transform: translate(100%, 0);
	}
	
	.slide-left-leave-active,
	.slide-right-enter {
	     opacity: 0;
	    -webkit-transform: translate(-100%, 0);
	    transform: translate(-100% 0);
	}
	// #app .van-nav-bar {
	// 	background-color: #1989fa;
	// 	color: #fff;
	// 	.van-nav-bar__title {
	// 		color: #fff;
	// 	}
	//  .van-icon {
	// 	 color: #fff;
	//  }
	// }
</style>
